<template>
    <div class="merchantAll">
        <merchant-Info v-if="checkStatus==1||checkStatus==10"></merchant-Info>
        <merchant-Upt v-if="showflag"></merchant-Upt>
        <check-Remark v-if="checkStatus==2  && !isRegister" @showflag="getState"></check-Remark>
        <div v-if="flag">
            <div class="footer" v-if="checkStatus==10">
                <el-button class="btnNew btnSize btn" @click="Upt">重新编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/fetch/api';
import merchantInfo from './merchantInfo'
import merchantUpt from './merchantUpt'
import checkRemark from './checkRemark' //审核驳回
export default {
    props:['isRegister'],
    components: {
        merchantInfo,merchantUpt,checkRemark
    },
    data(){
        return {
            checkStatus:'',
            showflag:false,
            state:null,
            flag:true,
        }
    },
    mounted () {
        this.getDetail ()
        this.getCondition ()
    },
    methods: {
        getCondition () {
            if(this.$route.query.state==88){
                this.flag = false
            }else{
                this.flag = true
            }
        },
        getDetail () {
            API.http({
                    fullUrl: '/merchant/audit_info',
                    type:'POST',
                }).then(res=>{
                    if(res.code==200){
                        this.checkStatus = res.data.checkStatus
                    }
                })
        },
        Upt () {
            this.showflag = true
            this.checkStatus = 100//随便加一个判断条件
        },
        getState (data) {
            if(data==1){
                this.showflag = true
                this.checkStatus = 100//随便加一个判断条件
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.footer{
        width:calc(100% - 220px);
        position: fixed;
        bottom:0;
        background-color: #fff;
        margin-left: -20px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        .redbtn{
            background-color:#f56c6c;
            color: #fff;
        }
    }
</style>